import React, { PureComponent } from "react";
import { wire } from "react-hot-wire";
import { WithTranslation, withTranslation } from "react-i18next";

import CircularProgress from "@material-ui/core/CircularProgress";

import { SiteService } from "services/site/Site.service";

import { Import } from "models/application/Import";
import { Application } from "models/application/Application";

export class ImportLogs extends PureComponent<
  {
    siteService: SiteService;
    application: Application;
    setApplicationState: Function;
  } & WithTranslation
> {
  private __cachedPolling: number = 0;
  private unregisterScrollListener: () => void = () => {};
  private isMoving: boolean = false;
  private logs = React.createRef<HTMLDivElement>();

  state: { import?: Import | null } = {
    // undefined value is used for detect "request-end" process
    import: undefined
  };

  render() {
    const { t } = this.props;
    // latestImport because.."import" is reserved word
    const { import: latestImport } = this.state;

    return (
      <div
        className="modal-body overflow-auto"
        style={{ height: 0 }}
        ref={this.logs}
      >
        {latestImport === undefined ? (
          <div className="d-flex align-items-center justify-content-center h-100">
            <CircularProgress />
          </div>
        ) : (
          <pre style={{ whiteSpace: "pre-wrap" }}>
            {latestImport && latestImport.log
              ? latestImport.log
              : t("application.preview.emptyLogs")}
          </pre>
        )}
      </div>
    );
  }

  componentDidMount() {
    this.fetchJob().then(() => {
      // first, move to the last log message
      this.logs.current!.scrollTop = this.logs.current!.scrollHeight;
    });
    this.unregisterScrollListener = this.registerScrollListener();
  }

  private async fetchJob() {
    const { siteService, application, setApplicationState } = this.props;
    // latest import is directly job:
    const {
      latestImport
    }: { latestImport?: Import } = await siteService.fetchApplication({
      application
    });

    return new Promise<void>(resolve =>
      this.setState(
        {
          import: latestImport
        },
        resolve
      )
    ).then(() => {
      setApplicationState(
        latestImport
          ? this.jobState(latestImport.state)
          : this.jobState("not-deployed-yet")
      );

      // run polling (request, refresh etc.) process only in the "in-progress" state
      if (latestImport && latestImport.state === "in-progress") {
        this.runPollingProcess();
      }
    });
  }

  private runPollingProcess() {
    if (!this.isMoving) {
      this.logs.current!.scrollTop = this.logs.current!.scrollHeight;
    }

    this.__cachedPolling = window.setTimeout(() => this.fetchJob(), 1000);
  }

  private jobState(state: string) {
    return (
      <span className="badge badge-warning mr-2">
        {this.props.t(`application.preview.status.${state}`)}
      </span>
    );
  }

  private registerScrollListener() {
    const logContainer = this.logs.current!;

    const listener = () => {
      const { scrollHeight, scrollTop, offsetHeight } = this.logs.current!;

      this.isMoving = scrollHeight - (scrollTop + offsetHeight) > 0;
    };

    logContainer.addEventListener("scroll", listener);

    return () => window.removeEventListener("scroll", listener);
  }

  componentWillUnmount() {
    this.unregisterScrollListener();
    window.clearTimeout(this.__cachedPolling);
  }
}

export default wire(["siteService"], withTranslation()(ImportLogs));
